<template>
  <tr class='w-table-data-footer fixed-sum-table-row'>
    <slot
      name='footer-inner-append'
      :aggregations='aggregations'
    >
      <td
        v-for='(header, index) in headers'
        :key='index'
        :class='getClasses(header)'
      >
        <span>{{ getAggregation(header) }}</span>
      </td>
    </slot>
  </tr>
</template>

<script>
const _getAlignment = (header) => {
  return header.alignValue || header.align
    ? `text-${header.alignValue ?? header.align}`
    : '';
}

/**
 * @component WorkDataTableFooter
 * @description Footer for `WorkDataTable`. Optionally displays an aggregated value per column
 * (e.g. sum, average) if present in `aggregations`.
 *
 * @prop {Array} headers - Column definitions of the parent table. (Required)
 * @prop {Object} [aggregations] - Aggregation values matching the column keys.
 */
export default {
  name: 'WorkDataTableFooter',
  props: {
    headers: { type: Array, required: true },
    aggregations: { type: Object, required: false },
  },
  methods: {
    getClasses(header) {
      const alignment = _getAlignment(header);
      return `${alignment}`;
    },
    getAggregation(header) {
      if (header == undefined || this.aggregations == undefined)
        return
      const aggregationValue = this.aggregations[header.value];
      if (aggregationValue == undefined) { return undefined }

      return header.presentWith != undefined ? header.presentWith(aggregationValue) : aggregationValue;
    },
  }
};
</script>

<style lang='scss' scoped>
.w-table-data-footer td {
  cursor: default !important;
}
</style>
